export default __webpack_public_path__ + "static/media/TicTac-Learn-Website_element-21-2.d94a8a62.png";